import React from 'react';
import { useStorageUrl } from './MemberAvatar';

/**
 * A group's icon. If the group has a generated/uploaded logo, that's shown; otherwise we render a
 * Gmail-contact-style INITIAL avatar — the group name's first letter in a circle, on a neutral shade
 * derived from the name (monochrome-first per the design rules, but varied enough to tell groups
 * apart). Assigned automatically on create; the logo replaces it the moment the owner makes one.
 */
const SHADES = ['bg-secondary-700', 'bg-secondary-600', 'bg-secondary-800', 'bg-secondary-500', 'bg-secondary-900'];

const GroupAvatar: React.FC<{ name: string; logoUrl?: string | null; logoPath?: string | null; className?: string }>
  = ({ name, logoUrl, logoPath, className = 'w-8 h-8' }) => {
  const fromPath = useStorageUrl(logoUrl ? null : logoPath); // resolve a storage path only if no direct url
  const url = logoUrl || fromPath;
  if (url) return <img src={url} alt="" className={`${className} shrink-0 rounded-full object-cover`} />;
  const initial = (name || '').trim().charAt(0).toUpperCase() || '#';
  let h = 0; for (const c of name || '') h = (h * 31 + c.charCodeAt(0)) | 0;
  const shade = SHADES[Math.abs(h) % SHADES.length];
  return (
    <span className={`${className} shrink-0 rounded-full ${shade} text-white flex items-center justify-center font-semibold`} aria-hidden>
      {initial}
    </span>
  );
};

export default GroupAvatar;
